import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';

import { GBENSContext } from '../GBENSContainer';
import Row from './_Row';

export const DateTimePickerComponent = ({ id, screen, modal, name, toolTip, rowProps, disabled }) => {
  const { data, updateData, errors } = useContext(GBENSContext);
  const _error = errors?.[screen]?.[id] ? errors[screen][id] : null;

  useEffect(() => {
    if (typeof dateInObject === 'string') updateData(dayjs(dateInObject), screen, id + 'DateTime', modal);
  }, [data]);

  const dateInObject = useMemo(() => {
    return modal ? data?.[screen]?.[modal]?.[id + 'DateTime'] : data?.[screen]?.[id + 'DateTime'];
  }, [data]);

  const updateDateComponent = (e, type) => {
    let newDate;
    switch (type) {
      case 'date':
        newDate = dayjs();
        newDate = newDate.year(e.year());
        newDate = newDate.month(e.month());
        newDate = newDate.date(e.date());
        if (!dateInObject) {
          newDate = newDate.hour(0);
          newDate = newDate.minute(0);
        } else {
          newDate = newDate.hour(dayjs(dateInObject).hour());
          newDate = newDate.minute(dayjs(dateInObject).minute());
        }

        if (dayjs(newDate).isValid()) {
          updateData(newDate, screen, id + 'DateTime', modal);
        }
        break;
      case 'time':
        if (!dateInObject) {
          newDate = dayjs();
          newDate = newDate.hour(e.hour());
          newDate = newDate.minute(e.minute());
        } else {
          newDate = dayjs(dateInObject);
          newDate = newDate.hour(e.hour());
          newDate = newDate.minute(e.minute());
        }

        if (dayjs(newDate).isValid()) {
          updateData(newDate, screen, id + 'DateTime', modal);
        }
        break;
    }
  };

  return (
    <Row
      name={name}
      warning={_error}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: 20 }}>
              <DatePicker
                id={id + 'DateTime'}
                onChange={(e) => updateDateComponent(e, 'date')}
                value={dateInObject}
                format="DD/MM/YYYY"
                disabled={disabled}
              />
            </div>
            <div>
              <DesktopTimePicker
                value={dateInObject}
                onChange={(e) => {
                  updateDateComponent(e, 'time');
                }}
                ampm={false}
                sx={{ maxWidth: 150 }}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

DateTimePickerComponent.propTypes = {
  id: PropTypes.string,
  screen: PropTypes.string,
  modal: PropTypes.string,
  name: PropTypes.string,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default DateTimePickerComponent;
